import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {hideLoader, showLoader} from 'app/redux/loaderSlice'
import {showMessage} from 'app/redux/messageSlice'
import {setTotalCount} from 'app/redux/pagingSlice'
import ShippingPackageService from 'app/services/ShippingPackageService'
import {setShippingPackage} from '../fulfillment/orderSlices'

export const getShippingPackages = createAsyncThunk(
  'fulfillment/getShippingPackages',
  async (filter: any, {dispatch, rejectWithValue}) => {
    try {
      dispatch(setFetching(true))
      const {data, totalCount} = await ShippingPackageService.list(filter)
      dispatch(setTotalCount(totalCount))
      if (totalCount === 1) {
        dispatch(setShippingPackage(data[0]))
      }
      return data
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({text: 'Error occurred while getting shipping packages', variant: 'error'})
      )
      return rejectWithValue(error)
    } finally {
      dispatch(setFetching(false))
    }
  }
)

export const getAllShippingPackages = createAsyncThunk(
  'fulfillment/getShippingPackages',
  async (_, {dispatch, rejectWithValue}) => {
    try {
      dispatch(setFetching(true))
      const data = await ShippingPackageService.all()
      return data
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({text: 'Error occurred while getting shipping packages', variant: 'error'})
      )
      return rejectWithValue(error)
    } finally {
      dispatch(setFetching(false))
    }
  }
)

export const getShippingPackageDetail = createAsyncThunk(
  'shipping/package',
  async (id: string, {dispatch}) => {
    dispatch(showLoader())
    const booking = await ShippingPackageService.getShippingDetail(id)
    dispatch(hideLoader())
    return booking
  }
)

const initialState = {
  list: [],
  entity: '',
  isFetching: false,
}

const shippingPackageSlice = createSlice({
  name: 'shippingPackage',
  initialState,
  reducers: {
    setFetching: (state, action) => {
      state.isFetching = action.payload
    },

    resetShippingPackage: (state) => {
      return initialState
    },
  },
  extraReducers: {
    [getShippingPackages.fulfilled.toString()]: (state, action) => {
      state.list = action.payload
    },
    [getShippingPackageDetail.fulfilled.toString()]: (state, action) => {
      state.entity = action.payload
    },
  },
})

export const {setFetching, resetShippingPackage} = shippingPackageSlice.actions
export default shippingPackageSlice.reducer
